import { Exchange } from './exchange';
import { Rate } from './rate';

export class ExchangeRates {
    rates: Record<string, Rate> = {};

    constructor(data: Record<string, Exchange>) {
        Object.entries(data).forEach(([pair, exchange]) => {
            const [to, from] = pair.split('-');

            if (!this.rates[from]) {
                this.rates[from] = {
                    eur: 0,
                    pln: 0,
                };
            }

            this.rates[from][to] = exchange.rate;
        });
    }
}
